import React from 'react';
import cn from '@/utils/cn';

interface SkeletonProps {
  /** Number of placeholder bars to render. */
  count?: number;
  /** Classes applied to each bar (size/shape overrides). */
  className?: string;
  /** Classes applied to the wrapper (alignment/spacing). */
  containerClassName?: string;
  /** Accessible description of what is loading. */
  ariaLabel?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({
  count = 1,
  className,
  containerClassName,
  ariaLabel = 'Loading'
}) => (
  <span
    role="status"
    aria-label={ariaLabel}
    className={cn('flex flex-col gap-y-1', containerClassName)}>
    {Array.from({ length: count }).map((_, index) => (
      <span
        key={index}
        className={cn('block h-3 w-32 animate-pulse rounded bg-aux-wizardwhite', className)}
      />
    ))}
  </span>
);

export default Skeleton;
